// In-game achievements

export const achievements = {
    unlucky: {
        title: 'भाग्यमानी हैन (No Luck Today)',
        description: 'Roll six different symbols in one go.',
        unlocked: false,
        check: (counts) => {
            const symbols = Object.keys(counts);
            return symbols.length === 6;
        }
    },
    redExplosion: {
        title: 'रातो धमाका (Red Explosion)',
        description: 'All dice show red symbols (Hearts/Diamonds).',
        unlocked: false,
        check: (counts) => {
            const symbols = Object.keys(counts);
            return symbols.every(s => s === 'heart' || s === 'diamond') && symbols.length > 0;
        }
    },
    blackMagic: {
        title: 'कालो जादू (Black Magic)',
        description: 'All dice show black symbols (Spades/Clubs).',
        unlocked: false,
        check: (counts) => {
            const symbols = Object.keys(counts);
            return symbols.every(s => s === 'spade' || s === 'club') && symbols.length > 0;
        }
    },
    royalCourt: {
        title: 'राज दरबार (Royal Court)',
        description: 'All dice show Crown or Flag. Royalty!',
        unlocked: false,
        check: (counts) => {
            const symbols = Object.keys(counts);
            return symbols.every(s => s === 'crown' || s === 'flag') && symbols.length > 0;
        }
    },
    emptyPockets: {
        title: 'खाली खल्ती (Empty Pockets)',
        description: 'Lost everything. Kangal bhayo!',
        unlocked: false,
        check: (counts, balance) => balance === 0
    },
    confusedSoul: {
        title: 'अलमल परेको (Confused Soul)',
        description: 'Bet on all symbols at once.',
        unlocked: false,
        check: (counts, balance, bets) => {
            const betSymbols = Object.keys(bets).filter(symbol => bets[symbol] > 0);
            return betSymbols.length === 6;
        }
    },
    // New betting achievements
    fish: {
        title: 'माछा (Fish)',
        description: 'Bet 1,000 at once. Swimming upstream!',
        check: (counts, balance, bets, totalBet) => totalBet >= 1000
    },
    tiger: {
        title: 'बाघ (Tiger)',
        description: 'Bet 5,000 at once. Hunting for big wins!',
        check: (counts, balance, bets, totalBet) => totalBet >= 5000
    },
    elephant: {
        title: 'हात्ती (Elephant)',
        description: 'Bet 10,000 at once. Big money moves!',
        check: (counts, balance, bets, totalBet) => totalBet >= 10000
    },
    // New winning achievements
    smallJoy: {
        title: 'सानो खुशी (Small Joy)',
        description: 'Won 2,000 at once. Chiya kharcha ta bhayo!',
        check: (counts, balance, bets, totalBet, winnings) => winnings >= 2000
    },
    sweetVictory: {
        title: 'रमाईलो जित (Sweet Victory)',
        description: 'Won 5,000 at once. Dashain kharcha aayo!',
        check: (counts, balance, bets, totalBet, winnings) => winnings >= 5000
    },
    millionaireDreams: {
        title: 'करोडपति सपना (Millionaire Dreams)',
        description: 'Won 10,000 at once. Now buy momos for everyone!',
        check: (counts, balance, bets, totalBet, winnings) => winnings >= 10000
    },
    // New losing achievements
    bigLoser1: {
        title: 'अलि दुख्यो (It Hurts a Bit)',
        description: 'Lose 2,000 at once. Oops!',
        check: (counts, balance, bets, totalBet, winnings, loss) => loss >= 2000
    },
    bigLoser2: {
        title: 'धेरै दुख्यो (Really Hurts)',
        description: 'Lose 5,000 at once. Serious loss!',
        check: (counts, balance, bets, totalBet, winnings, loss) => loss >= 5000
    },
    bigLoser3: {
        title: 'धेरै धेरै दुख्यो (Hurts a Lot)',
        description: 'Lose 10,000 at once. Loan chaiyo?',
        check: (counts, balance, bets, totalBet, winnings, loss) => loss >= 10000
    },
    // Game count achievements
    tenGames: {
        title: 'दस खेल (Ten Games)',
        description: 'Played 10 games. Loving the game?',
        check: (counts, balance, bets, totalBet, winnings, loss, gamesPlayed) => gamesPlayed >= 10
    },
    twentyFiveGames: {
        title: 'पच्चिस पटक (Twenty Five Club)',
        description: 'Played 25 games. You\'re hooked!',
        check: (counts, balance, bets, totalBet, winnings, loss, gamesPlayed) => gamesPlayed >= 25
    },
    fiftyGames: {
        title: 'पचास यात्रा (Fifty Journeys)',
        description: 'Played 50 games. Touch some grass maybe?',
        check: (counts, balance, bets, totalBet, winnings, loss, gamesPlayed) => gamesPlayed >= 50
    },
    // Stubborn gambler achievements
    stubborn1: {
        title: 'एकै ठाउँमा (Stubborn Gambler)',
        description: '5 consecutive bets on same symbol.',
        check: () => false 
    },
    stubborn2: {
        title: 'एकै ठाउँमा (Die Hard Fan)',
        description: '10 consecutive bets on same symbol.',
        check: () => false 
    },
    stubborn3: {
        title: 'एकै ठाउँमा (Obsessed)',
        description: '15 consecutive bets on same symbol.',
        check: () => false
    },
    // Matching dice achievements
// pair: {
//     title: 'जोडी (Pair)',
//     description: 'Got 2 matching symbols in one roll. Suru bhayo, lucky feeling aayo!',
//     check: (counts) => {
//         return Object.values(counts).some(count => count === 2);
//     }
// },
// threeOfAKind: {
//     title: 'तीन पत्ती (Three of a Kind)',
//     description: 'Got 3 matching symbols in one roll. Now we\'re talking! Ramro chha!',
//     check: (counts) => {
//         return Object.values(counts).some(count => count === 3);
//     }
// },
fourOfAKind: {
    title: 'चार चाहिँ (Four Power)',
    description: 'Got 4 matching symbols in one roll!',
    // description: 'Got 4 matching symbols in one roll! Lady luck is winking at you!',
    check: (counts) => {
        return Object.values(counts).some(count => count === 4);
    }
},
fiveFlowers: {
    title: 'पञ्च फूल (Five Flowers)',
    description: 'Got 5 matching symbols in one roll!',
    // description: 'Got 5 matching symbols in one roll! Almost perfect, ali ali chha!',
    check: (counts) => {
        return Object.values(counts).some(count => count === 5);
    }
},
perfectSix: {
    title: 'छक्का पञ्जा (Perfect Six)',
    description: 'Got 6 matching symbols in one roll!',
    // description: 'All 6 dice match! JACKPOT BHAYO! Lottery jityo jasto feel!',
    check: (counts) => {
        return Object.values(counts).some(count => count === 6);
    }
}
// ,
// riskTaker: {
//     title: 'रिस्क लिने (Risk Taker)',
//     description: 'Bet your entire balance in one go! Himmat ta chha, respect!',
//     check: (counts, balance, bets, totalBet, winnings, loss, gamesPlayed, previousBalance) => {
//         return totalBet === previousBalance && previousBalance > 0;
//     }
// }
};
